import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CanDirective, CapabilityNames } from 'core';

interface CheckVerificationRow {
  numeroAssegno: string;
  verificato?: boolean;
  selezionato?: boolean;
  selezionaAssegno?: (checked: boolean) => void;
}

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-check-verification-cell',
  imports: [TranslocoPipe, CanDirective, MatCheckboxModule],
  template: `
    @if (itemData.verificato) {
      <i
        class="fa-regular fa-check check-verified-icon"
        [attr.aria-label]="(('receipts.ui.assegno' | transloco) + &quot; &quot;) + itemData.numeroAssegno + (&quot; &quot; + ('receipts.ui.verificato' | transloco))"
      ></i>
    } @else {
      <mat-checkbox
        *uiCan="CAPS.distintaVerifica"
        [checked]="itemData.selezionato ?? false"
        [attr.aria-label]="(('receipts.ui.verificaAssegno' | transloco) + &quot; &quot;) + itemData.numeroAssegno"
        (change)="seleziona($event.checked)"
        (click)="$event.stopPropagation()"
      />
    }
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .check-verified-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: var(--mat-sys-success);
      font-size: 24px;
      line-height: 24px;
    }
  `,
})
export class receiptsCheckVerificationCell {
  readonly CAPS = CapabilityNames;

  @Input({ required: true }) itemData!: CheckVerificationRow;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };

  seleziona(checked: boolean): void {
    this.itemData.selezionato = checked;
    this.itemData.selezionaAssegno?.(checked);
  }
}
